import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { url } from "../Api";
import logo from "../Assets/logo sts.jpg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        <NavLink to="/" className="nav-logo" onClick={closeMenu}>
          <img src={logo} width={80} height={40} alt="logo" />
        </NavLink>

        {/* Hamburger for mobile */}
        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <li className="nav-item">
            <NavLink to="/" className="nav-link" activeClassName="active" onClick={closeMenu}>
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/about" className="nav-link" activeClassName="active" onClick={closeMenu}>
              About
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/course" className="nav-link" activeClassName="active" onClick={closeMenu}>
              Training
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/placement"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Placement
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/review" className="nav-link" activeClassName="active" onClick={closeMenu}>
              Offers
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/consultancy"
              className="nav-link"
              activeClassName="active"
              onClick={closeMenu}
            >
              Consultancy
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/career" className="nav-link" activeClassName="active" onClick={closeMenu}>
              Career
            </NavLink>
          </li>

          {/* Dropdown */}
          <li className="nav-item dropdown">
            <NavLink to="/project" className="nav-link" activeClassName="active" onClick={closeMenu}>
              Projects ▾
            </NavLink>
            <div className="dropdown-content">
              <NavLink to="/projects/Python" onClick={closeMenu}>Python Projects</NavLink>
              <NavLink to="/projects/Java" onClick={closeMenu}>Java Projects</NavLink>
              <NavLink to="/projects/DotNet" onClick={closeMenu}>Dot Net Projects</NavLink>
              <NavLink to="/projects/PHP" onClick={closeMenu}>Php Projects</NavLink>
              <NavLink to="/projects/Mern" onClick={closeMenu}>Mern Projects</NavLink>
              <NavLink to="/projects/Mini" onClick={closeMenu}>Mini Projects</NavLink>
            </div>
          </li>

          <li className="nav-item">
            <NavLink to="/gallery" className="nav-link" activeClassName="active" onClick={closeMenu}>
              Events
            </NavLink>
          </li>
          <li className="nav-item">
            <a
              href={url}
              className="nav-link nav-btn"
              style={{
                background: "linear-gradient(90deg, #1F2661, #122894, #1f68d5)",
                color: `rgb(255, 255, 255)  `
              }}
              onClick={closeMenu}
            >
              Login
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
